import React from "react";

import youtubeLogo from "../../assets/svg/youtube-logo.svg";
import linkedinLogo from "../../assets/svg/linkedin-logo.svg";
import facebookLogo from "../../assets/svg/facebook-logo.svg";
import { Icon } from "../Icon/Icon";

import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";

import "./Footer.scss";
import cs from "classnames";

const Footer = () => {
  const { ref: buttonRef, inView: buttonVisibility } = useInView();

  const navigate = useNavigate();

  const productsList = [
    { name: "Infinite 353", path: "/infinite-353" },
    { name: "Infinite 60", path: "/infinite-60" },
    { name: "Infinite 50", path: "/infinite-50" },
    { name: "Infinite 313", path: "/infinite-313" },
    { name: "Infinite 110", path: "/infinite-110" },
  ];
  const businessSolutionsList = [
    { name: "About Us", path: "/about" },
    { name: "Support", path: "/support" },
    { name: "Business", path: "/infinite-for-businesses" },
    { name: "Register Interest", path: "/register-interest" },
  ];

  return (
    <div className="Footer">
      <div className="Footer__container">
        <div className="Footer__top">
          <div className="Footer__top-left">
            <Icon className="Footer__infiniteLogo" icon="infinite-lg" />
            <div>
              <div className="Footer__socialMedia-label">Follow Us</div>
              <div className="Footer__socialMedia">
                <img
                  loading="lazy"
                  className="Footer__socialMedia-icon"
                  alt="youtube-logo"
                  src={youtubeLogo}
                  onClick={() => {
                    window.open(
                      "https://www.youtube.com/channel/UCNcmjtGuRj0GFejE_kuaZbg",
                      "_blank",
                    );
                  }}
                />
                <img
                  loading="lazy"
                  className="Footer__socialMedia-icon"
                  alt="linkedin-logo"
                  src={linkedinLogo}
                  onClick={() => {
                    window.open(
                      "https://www.linkedin.com/company/infinite-clouds/",
                      "_blank",
                    );
                  }}
                />
                <img
                  loading="lazy"
                  className="Footer__socialMedia-icon"
                  alt="facbook-logo"
                  src={facebookLogo}
                  onClick={() => {
                    window.open(
                      "https://www.facebook.com/infinitecloudss",
                      "_blank",
                    );
                  }}
                />
              </div>
            </div>
          </div>
          <div className="Footer__top-right">
            <div className="Footer__top-right-top">
              <div className="Footer__list">
                <div className="Footer__list-head">Products</div>
                {productsList.map((item) => (
                  <div
                    className="Footer__list-item"
                    onClick={() => {
                      navigate(item.path);
                    }}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
              <div className="Footer__list">
                <div className="Footer__list-head">Useful Links</div>
                {businessSolutionsList.map((item) => (
                  <div
                    className="Footer__list-item"
                    onClick={() => {
                      navigate(item.path);
                    }}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            </div>
            <div className="Footer__top-right-bottom">
              <div className="Footer__register">
                <div>
                  <div className="Footer__register-labelOne">
                    Discover Exclusive Access
                  </div>
                  <div className="Footer__register-labelTwo">
                    Join us by registering now and stay connected with our
                    cutting-edge advancements.
                  </div>
                </div>
                <div
                  ref={buttonRef}
                  className={cs(
                    "Footer__register-button-outside",
                    buttonVisibility &&
                      "Footer__register-button-outside-animation",
                  )}
                >
                  <div
                    className={cs(
                      "Footer__register-button-middle",
                      buttonVisibility &&
                        "Footer__register-button-middle-animation",
                    )}
                  >
                    <div
                      className="Footer__register-button"
                      onClick={() => {
                        navigate("/register-interest");
                      }}
                    >
                      Register Interest
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Footer__bottom">
          <div className="Footer__bottom-labelOne">
            &#169; 2025 Infinite Clouds &#174; All Rights Reserved
          </div>
          <div>
            OFFICE NO.406 RD 3307 BLK 333 MANAMA, BAHRAIN |
            info@infiniteclouds.com
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
